import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { getCockpitKeyInitiativesDataForPartners } from '../../lib'
import { selectCockpitKeyInitiatives, selectCockpitMdfActivities } from '../selectors'

import { useFilteredCockpitPartnerData } from './useFilteredCockpitPartnerData'

export interface ICockpitKeyInitiativesDataOptions {
  /** Narrows the widget to the partners currently shown by the manager cockpit filters. */
  isManagerCockpitMode?: boolean
}

export const useCockpitKeyInitiativesData = ({
  isManagerCockpitMode = false,
}: ICockpitKeyInitiativesDataOptions = {}) => {
  const initiatives = useSelector(selectCockpitKeyInitiatives)
  const mdfActivities = useSelector(selectCockpitMdfActivities)
  const filteredPartnerData = useFilteredCockpitPartnerData()

  return useMemo(
    () =>
      getCockpitKeyInitiativesDataForPartners({
        initiatives,
        mdfActivities,
        partnerIds: isManagerCockpitMode
          ? filteredPartnerData.map(({ PartnerId }) => PartnerId)
          : null,
      }),
    [initiatives, mdfActivities, isManagerCockpitMode, filteredPartnerData]
  )
}
